/*
 * Kohinoor SmartShop™ — Product Image Rotation (Cross-fade)
 * - Fades between images (no white flash)
 * - Runs only when the card is on screen
 * - Pauses on hover/touch + respects reduced motion
 */

(() => {
  const INTERVAL_MS = 2500;     // change time
  const FADE_MS = 400;          // fade duration

  // If user prefers reduced motion, do nothing
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Helper: start a rotator for one media container
  function startRotator(media) {
    const imgs = media.querySelectorAll('img');
    if (!imgs || imgs.length < 2) return;

    // Ensure container can stack absolutely-positioned children
    const style = media.style;
    if (getComputedStyle(media).position === 'static') style.position = 'relative';
    style.overflow = 'hidden';

    // Prepare images for cross-fade
    imgs.forEach((img, i) => {
      img.decoding = 'async';
      img.loading = img.loading || 'lazy';
      Object.assign(img.style, {
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: `opacity ${FADE_MS}ms ease`,
        opacity: i === 0 ? '1' : '0',
        pointerEvents: 'none'
      });
    });

    let idx = 0;
    let timer = null;

    const next = () => {
      const cur = imgs[idx];
      const nxt = imgs[(idx + 1) % imgs.length];
      // Bring next to front and fade
      nxt.style.opacity = '1';
      cur.style.opacity = '0';
      idx = (idx + 1) % imgs.length;
    };

    const start = () => { stop(); timer = setInterval(next, INTERVAL_MS); };
    const stop  = () => { if (timer) { clearInterval(timer); timer = null; } };

    // Pause on hover/touch
    media.addEventListener('mouseenter', stop, { passive: true });
    media.addEventListener('mouseleave', start, { passive: true });
    media.addEventListener('touchstart', stop, { passive: true });
    media.addEventListener('touchend', () => setTimeout(start, 500), { passive: true });

    // Start when visible
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => e.isIntersecting ? start() : stop());
    }, { rootMargin: '0px 0px 200px 0px', threshold: 0.05 });

    io.observe(media);
  }

  // Find media blocks inside product cards (covers Dawn/Balance and most themes)
  const mediaSelectors = [
    '.card-wrapper .card__media',
    '.product-card .card__media',
    '.product-card .media',
    '.card-wrapper .media',
    '.collection-product-card .media'
  ];
  const medias = document.querySelectorAll(mediaSelectors.join(','));

  // Fallback: if we didn’t match a media wrapper, try using the card itself
  if (medias.length === 0) {
    document.querySelectorAll('.card-wrapper, .product-card, .grid__item').forEach(card => {
      const media = card.querySelector('.media, .card__media') || card;
      startRotator(media);
    });
  } else {
    medias.forEach(startRotator);
  }
})();
